import { render } from "./SurveyTable.vue?vue&type=template&id=3a4a914c&scoped=true"
import script from "./SurveyTable.vue?vue&type=script&lang=js"
export * from "./SurveyTable.vue?vue&type=script&lang=js"

import "./SurveyTable.vue?vue&type=style&index=0&id=3a4a914c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4a914c"]])

export default __exports__